import Link from 'next/link';
import styles from '../../page.module.scss';
import asterix from '../../assets/decos/asterix.svg';

export default function Typeo() {
  return (
    <div className={styles.typeoContainer}>
      <div>
        <img src={asterix.src} alt="imagen decorativa" />
        <p className={styles.text} style={{ textAlign: 'center', fontSize: '0.9rem' }}>
          La Libre Editora forma parte de TyPEO, una cooperativa de provisión de servicios para la
          actividad editorial integrada por diez editoriales independientes argentinas. Desde este
          proyecto, buscamos promover la bibliodiversidad, generar redes de trabajo para la
          industria editorial independiente y fomentar la difusión y militancia de la organización
          cooperativa.
        </p>
      </div>
      <Link target="_blank" href={'https://typeo.com.ar/'}>
        {' '}
        <div className={styles.typeoLogoContainer}>
          <img
            src="https://typeo.com.ar/wp-content/uploads/2023/12/BN-Logos-TyPEO-03.png.webp"
            alt="logo de TyPEO"
          />
        </div>
      </Link>
    </div>
  );
}
